import { Stack } from "@mui/material";

import CreateUrlCard from "../AppSettings/CreateUrlPanel/CreateUrlCard";

// ----------------------------------------------------------------------

export const CreateUrlTab = () => {
	return (
		<Stack gap={3} sx={{ mt: 4 }}>
			<CreateUrlCard type={"active-positions"} />
		</Stack>
	);
};

export default CreateUrlTab;
